'use strict'
import React, { useState } from 'react'
import { Accordion } from '..'
import { AccordionData } from '../../utils'
import styles from './styles.module.css'

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null)

  const renderAccordions = () => {
    const accordions = []

    for (let i = 0; i < AccordionData.length; i += 3) {
      const group = AccordionData.slice(i, i + 3)

      accordions.push(
        <div key={i} className={styles.accordionGroup}>
          {group.map(({ id, ...rest }) => (
            <Accordion
              key={id}
              index={id}
              openIndex={openIndex}
              setOpenIndex={setOpenIndex}
              title={rest.title}
              intro={rest.intro}
              accordionContent={rest.answer?.map((content, index) => (
                <li key={index} className={styles.faqlist}>
                  {content}
                </li>
              ))}
            />
          ))}
        </div>
      )
    }

    return accordions
  }

  return (
    <div className={styles.faqContainer}>
      <div className={styles.faqInner}>
        <p className={styles.faqheading}>FAQs</p>
        <div className={styles.faqwrapper}>{renderAccordions()}</div>
      </div>
    </div>
  )
}

export default FAQ
